import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff705390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "parent" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt fa-lg" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "parent" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt fa-lg" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "parent" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt fa-lg" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "leaving" }
const _hoisted_16 = { class: "parent" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt fa-lg" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "parent" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "parent" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "parent" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "parent" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "parent" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "parent" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass({
      holiday: _ctx.isHoliday(),
      attendanceAlert: _ctx.item.isTooLong,
    })
  }, [
    _createElementVNode("td", null, _toDisplayString(_ctx.formatDateToJapanese(_ctx.item.c_attendance_date)), 1),
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _ctx.showRequestStatus()
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_3, [
        (
            _ctx.item.c_attendance_lat_work != null &&
            _ctx.item.c_attendance_lng_work != null
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.showMap(_ctx.item.c_attendance_lat_work, _ctx.item.c_attendance_lng_work)
          ))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.c_attendance_time_work) = $event))
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.item.c_attendance_time_work]
        ])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_work }]),
        style: {"display":"none"}
      }, "change", 2)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_7, [
        (
            _ctx.item.c_attendance_lat_goout_start != null &&
            _ctx.item.c_attendance_lng_goout_start != null
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
            _ctx.showMap(
              _ctx.item.c_attendance_lat_goout_start,
              _ctx.item.c_attendance_lng_goout_start
            )
          ))
            }, _hoisted_9))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.c_attendance_time_goout_start) = $event))
        }, null, 8, _hoisted_10), [
          [_vModelText, _ctx.item.c_attendance_time_goout_start]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_goout_start }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_11, [
        (
            _ctx.item.c_attendance_lat_goout_end != null &&
            _ctx.item.c_attendance_lng_goout_end != null
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (
            _ctx.showMap(
              _ctx.item.c_attendance_lat_goout_end,
              _ctx.item.c_attendance_lng_goout_end
            )
          ))
            }, _hoisted_13))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.c_attendance_time_goout_end) = $event))
        }, null, 8, _hoisted_14), [
          [_vModelText, _ctx.item.c_attendance_time_goout_end]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_goout_end }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (
            _ctx.item.c_attendance_lat_leaving != null &&
            _ctx.item.c_attendance_lng_leaving != null
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (
            _ctx.showMap(
              _ctx.item.c_attendance_lat_leaving,
              _ctx.item.c_attendance_lng_leaving
            )
          ))
            }, _hoisted_18))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.c_attendance_time_leaving) = $event))
        }, null, 8, _hoisted_19), [
          [_vModelText, _ctx.item.c_attendance_time_leaving]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_leaving }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.c_attendance_ot1_aftertime) = $event))
        }, null, 8, _hoisted_21), [
          [_vModelText, _ctx.item.c_attendance_ot1_aftertime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_aftertime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_22, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.c_attendance_ot2_nighttime) = $event))
        }, null, 8, _hoisted_23), [
          [_vModelText, _ctx.item.c_attendance_ot2_nighttime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_nighttime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.c_attendance_ot3_hd_aftertime) = $event))
        }, null, 8, _hoisted_25), [
          [_vModelText, _ctx.item.c_attendance_ot3_hd_aftertime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_hd_aftertime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.c_attendance_ot4_hd_nighttime) = $event))
        }, null, 8, _hoisted_27), [
          [_vModelText, _ctx.item.c_attendance_ot4_hd_nighttime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_hd_nighttime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.c_attendance_ot5_sp_aftertime) = $event))
        }, null, 8, _hoisted_29), [
          [_vModelText, _ctx.item.c_attendance_ot5_sp_aftertime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_sp_aftertime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_30, [
        _withDirectives(_createElementVNode("input", {
          type: "time",
          class: "time ml-auto",
          disabled: _ctx.isDisable,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.c_attendance_ot6_sp_nighttime) = $event))
        }, null, 8, _hoisted_31), [
          [_vModelText, _ctx.item.c_attendance_ot6_sp_nighttime]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-warning badge-pill", { isUpd: _ctx.item.c_attendance_flag_upd_sp_nighttime }]),
          style: {"display":"none"}
        }, "change", 2)
      ])
    ]),
    _createElementVNode("td", null, [
      _withDirectives(_createElementVNode("textarea", {
        class: "form-control form-control-sm p-1",
        disabled: _ctx.isDisable,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.cnvRemarks) = $event))
      }, null, 8, _hoisted_32), [
        [_vModelText, _ctx.item.cnvRemarks]
      ])
    ])
  ], 2))
}